<template>
  <div class="wrapper">
    <p class="title">{{info.title}}</p>
    <div class="subTitle">
      <span>作者：{{info.author}}</span>
      <span>{{info.createTime}}</span>
    </div>
    <div class="videoBox" v-if="info.videoUrl">
      <video-player
        v-if="playerShow"
        id="video"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="playsinline"
        :options="playerOptions"
      ></video-player>
      <div v-else class="videoImgBox">
        <img class="img" :src="(info.videoCover) +`${imgCrop}resize,w_700`"
        />
        <div class="player" @click="loadVideo">
          <img src="../../assets/images/newsPlay.png" alt=""/>
        </div>
      </div>
    </div>
    <div class="desc" v-html="info.detail"></div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  mixins: [weChatShareApi],
  data(){
    return {
      newsNbr:'',
      info:{},
      playerShow:false,
      playerOptions: {
        //playbackRates: [0.5, 1, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "1:1", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
//           {
          // type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
//           src: "" //url地址
//           }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          //timeDivider: true,
          //durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    }
  },
  computed:{
    playsinline() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        //ios端
        return true;
      }
    },
  },
  methods:{
    loadVideo() {
      let that = this;
      that.playerShow = true;
      setTimeout(() => {
        that.onPlayerCanplay();
        that.$refs.videoPlayer.player.play();
        that.$refs.videoPlayer.$refs.video.play();
      }, 200);
    },
    onPlayerCanplay() {
      //解决自动全屏
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        document.getElementsByTagName("video")[1].setAttribute("x-webkit-airplay", true);
        //document.getElementsByTagName('video')[0].setAttribute('x5-video-player-type','h5')
        document.getElementsByTagName("video")[1].setAttribute("x5-playsinline", true);
        //document.getElementsByTagName('video')[0].setAttribute('webkit-playsinline',true)
        //document.getElementsByTagName('video')[0].setAttribute('playsinline',true)
      } else {
        //ios端
        //document.getElementsByTagName('video')[0].setAttribute('webkit-playsinline',"true")
        //document.getElementsByTagName('video')[0].setAttribute('playsinline',"true")
      }
    },
    getData() {
      this.$post("/api/customer/news/queryBusinessNewsDetail", {
        'newsNbr': this.newsNbr,
      }).then((res) => {
        if (res.code == "200") {
          let resp = res.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            let news = resp.news
            news.createTime = news.createTime.substring(0, 10);
            news.updateTime = news.updateTime.substring(0, 10);
            if( news.videoCover && news.videoUrl){
              this.playerOptions.poster = news.videoCover;
              this.playerOptions.sources.push({
                src: news.videoUrl,
              });
            }
            this.info = resp.news;
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        } else {
          this.$toast({
            message: res.message,
            duration: 2000,
          });
        }
      })
        .catch((err) => {
          this.$toast({
            message: "您现在的网络不稳定，请稍后再试",
            duration: 2000,
          });
        });
    },
  },
  mounted() {
    
  },
  created(){
    this.newsNbr = this.$route.params.nbr
    this.getData()
    let option = {
      title: '有米@'+this.userInfo.name+'的店铺',
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl,
    };
    this.weChatShare(option)
  },
}
</script>

<style scoped lang='less'>
.wrapper {
  width: 100%;
  background: #fff;
}
.title{
  padding-top: .24rem;
  font-size: .3rem;
  color: #333;
  font-weight: bold;
  line-height: .42rem;
  width: 7.02rem;
  margin: 0 auto .12rem;
}
.subTitle{
  width: 7.02rem;
  margin: 0 auto .2rem;
  border-bottom: 1px solid #999;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: .53rem;
  span{
    font-size: .24rem;
    color: #999;
  }
}
.videoBox{
  width: 7.02rem;
  margin: 0 auto .2rem;
  .videoImgBox{
    width: 7.02rem;
    height: 7.02rem;
    position: relative;
    .img{
      width: 7.02rem;
      height: 7.02rem;
      object-fit: cover;
    }
    .player{
      width: 7.02rem;
      height: 7.02rem;
      position: absolute;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      img{
        width: 1.2rem;
        height: 1.2rem;
      }
    }
  }
}
.desc{
  width: 7.02rem;
  margin: 0 auto ;
  padding-bottom: .2rem;
  font-size: .24rem;
  color: #333;
}
</style>
<style scoped lang='stylus'>
  .videoBox >>> .video-js .vjs-big-play-button {
    border-radius: 50%;
    width: 1.2rem !important;
    height: 1.2rem !important;
    line-height: 1.2rem !important;
    margin-left: -0.6rem !important;
  }
  .desc >>> p,.desc >>> span{
    line-height: 1.5;
  }
  .desc >>> img{
    width: 100% !important;
    object-fit: contain;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/information/newsDetail.vue